import * as actionTypes from "../../constants/actionTypes";

const defaultPhoneSearchState = { query: "", results: [], searchTerms: null };

const phoneSearch = (state = defaultPhoneSearchState, action) => {
  switch (action.type) {
    case actionTypes.RESET_PHONE_SEARCH:
      return defaultPhoneSearchState;
    case actionTypes.UPDATE_PHONE_SEARCH:
      return { ...state, ...action.settings };
    default:
      return state;
  }
};

export default phoneSearch;
